import { render, staticRenderFns } from "./configuration-assays-modal.vue?vue&type=template&id=67382138&scoped=true&"
import script from "./configuration-assays-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-assays-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-assays-modal.scss?vue&type=style&index=0&id=67382138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67382138",
  null
  
)

export default component.exports